import { useTheme } from "@web-src/themes/useTheme";
import { FC, ReactElement, useState } from "react";
import { Resizable } from "react-resizable";

interface ResizableSidebarWrapperProps {
  sidebarWidth: number;
  onWidthChange: (width: number) => void;
  children: (isResizing: boolean) => ReactElement;
}

export const ResizableSidebarWrapper: FC<ResizableSidebarWrapperProps> = ({
  sidebarWidth,
  onWidthChange,
  children,
}) => {
  const { tcx } = useTheme();
  const [isResizing, setIsResizing] = useState(false);

  return (
    <Resizable
      className="relative h-full"
      width={sidebarWidth}
      axis="x"
      onResize={(_, data) => onWidthChange(data.size.width)}
      onResizeStart={() => setIsResizing(true)}
      onResizeStop={() => setIsResizing(false)}
      handle={
        <div
          className={tcx(
            "absolute top-0 right-0 z-[48] h-full w-1 cursor-ew-resize opacity-0 transition-opacity hover:opacity-100",
            {
              light: "bg-[#3690F2]",
              blue: "bg-[#103291]",
              dark: "bg-[#AFAFAF]",
            },
            isResizing && "opacity-100"
          )}
        />
      }
      draggableOpts={{ enableUserSelectHack: false }}
    >
      {children(isResizing)}
    </Resizable>
  );
};
